import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const LookupView = ({ value }: CustomAttributeReadProps) => {
  const lookup = getKindLikeValueSafely(value, 'lookup_relational');

  if (!lookup) {
    return <EmptyValue />;
  }

  return <AttributeText>{lookup.label ?? lookup.id}</AttributeText>;
};
